import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { User } from '@vsolv/core/users/domain';
import { firstValueFrom, interval, Subject, takeUntil } from 'rxjs';

@Injectable()
export class UserService implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private http: HttpClient) {
    interval(300000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateLastSignedIn();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async getOneByExternalId(externalId: string) {
    return firstValueFrom(this.http.get<User.Model>(`/v1/users/user/${externalId}`));
  }

  async getSelf() {
    return firstValueFrom(this.http.get<User.Model>(`/v1/users/self`));
  }

  async updateLastSignedIn() {
    return firstValueFrom(this.http.post<void>(`/v1/users/signed-in`, {}));
  }

  async updateUserProfile(body: User.UpdateUserProfileRequest, userId: string) {
    return firstValueFrom(this.http.post<User.UpdateUserProfileResponse>(`/v1/users/profile/update/${userId}`, body));
  }
}
